import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { Container, Stack } from '@mui/material';
import Footer from './Footer';
import Header from './Header';
import { useDevice } from '../../hooks/useResponsive';
import HeaderWeb from './HeaderWeb';
import Loader from './Loader';
import SpecialHeaderWeb from './SpecialHeaderWeb';
import SpecialHeader from './SpecialHeader';
import SpecialFooter from './SpecialFooter';

// import { useDevice } from '../../hooks/useResponsive';

export default function SimpleLayout() {
  const { isMobile } = useDevice();
  const [loading, setLoading] = useState(true);

  // console.log('loading', loading);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
  const hideFooterRoutes = [
    '/inspection-booking',
    '/inspection-booking-success',
    '/booking',
    '/pay-latter-success/:id',
    '/pay-latter-fail',
    '/payment-success/:id',
    '/payment-fail/:id',
    'verify',
    '/inspection',
    '/pdf-view/:id',
  ];
  const shouldShowFooter = !hideFooterRoutes.some((route) => matchPath({ path: route, end: true }, location.pathname));
  const specialHeaderRoutes = [
    '/inspection-booking',
    '/inspection-booking-success',
    '/booking',
    '/pay-latter-success/:id',
    '/pay-latter-fail',
    '/payment-success/:id',
    '/payment-fail/:id',
    'verify',
    '/inspection',
    '/pdf-view/:id',
  ];
  useEffect(() => {
    document.body.style.backgroundColor = shouldShowFooter ? '#121212' : 'white';
  }, [shouldShowFooter]);
  const isSpecialHeader = specialHeaderRoutes.some((route) => matchPath({ path: route, end: true }, location.pathname));
  // console.log('shouldShowFooter', isSpecialHeader);
  return (
    <>
      <Container
        maxWidth="xl"
        style={{ backgroundColor: shouldShowFooter ? '#121212' : 'white', paddingRight: '0px', paddingLeft: '0px' }}
      >
        {/* <Stack direction={'column'}>{isMobile ? <Header /> : <HeaderWeb />}</Stack> */}
        <Stack direction="column">
          {isSpecialHeader ? (
            // Special header (can be mobile & web variations)
            isMobile ? (
              <SpecialHeader />
            ) : (
              <SpecialHeaderWeb />
            )
          ) : // Default header
          isMobile ? (
            <Header />
          ) : (
            <HeaderWeb />
          )}
        </Stack>
        {/* <Outlet />
        <Footer /> */}
        {loading ? (
          <Loader shouldShowFooter={shouldShowFooter} />
        ) : (
          <div style={{ minHeight: shouldShowFooter ? '100vh' : 'auto' }}>
            <Outlet />
          </div>
        )}
        {!loading && (shouldShowFooter ? <Footer /> : <SpecialFooter />)}{' '}
      </Container>
    </>
  );
}
